"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var OurMountains = function OurMountains(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "".concat(className, " d8-svg-").concat(name),
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    width: "102px",
    height: "102px",
    viewBox: "0 0 102 102"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("polygon", {
    id: "path-1",
    points: "0.154612245 0.0285098039 19.9938776 0.0285098039 19.9938776 19.694 0.154612245 19.694"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    id: "path-3",
    points: "0 0.32076 18.9772 0.32076 18.9772 17.83396 0 17.83396"
  })), /*#__PURE__*/_react["default"].createElement("g", {
    id: "\uD83E\uDDE9-Destinations-guide",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Destinations-guide---Desktop",
    transform: "translate(-446.000000, -1978.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Group-15",
    transform: "translate(0.000000, 1688.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Group-27",
    transform: "translate(497.000000, 341.000000) rotate(-90.000000) translate(-497.000000, -341.000000) translate(446.000000, 290.000000)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M59.850743,7.90642535 C58.8700375,11.3038081 59.6472593,13.4497744 62.0218866,14.1591356 C64.3711272,14.8613435 66.166158,13.4843484 67.1468635,10.0869656 C68.1271783,6.68958292 67.3499566,4.54401394 65.0003254,3.84140865 C62.6256981,3.13204753 60.8314484,4.50904263 59.850743,7.90642535 M71.4993053,11.3880571 C69.9518919,16.7482043 66.0118853,19.0420039 61.0411811,17.5565183 C56.0696958,16.0706353 53.9504972,11.965481 55.49752,6.60533387 C57.0449334,1.24518672 61.009936,-1.04145969 65.9810308,0.444423333 C70.9521256,1.92990896 73.0467187,6.02790995 71.4993053,11.3880571",
    id: "Fill-1",
    fill: "#2EAEAD"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M86.5507172,26.5247196 C83.0068367,29.9817578 79.3791251,29.8025488 75.7602802,26.0819443 C72.1591688,22.3803101 72.0563951,18.724689 75.6002756,15.2676508 L83.0495584,8 L86.2605325,11.3008357 L78.7540189,18.6241866 C76.9439919,20.3900409 76.8101845,22.0081689 78.331639,23.5726149 C79.872439,25.1564348 81.5095643,25.0837825 83.3195913,23.3179283 L90.826105,15.9945773 L94,19.2570688 L86.5507172,26.5247196 Z",
    id: "Fill-3",
    fill: "#2EAEAD"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Group-7",
    transform: "translate(82.000000, 29.000000)"
  }, /*#__PURE__*/_react["default"].createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/_react["default"].createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Clip-6"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.8027755,6.32890196 L11.6607347,9.24301961 C12.1954286,11.0606667 13.0778776,11.681451 14.6072653,11.2661569 C16.1109388,10.8575294 16.5244082,9.88458824 15.9893061,8.06654902 L15.1313469,5.15282353 L10.8027755,6.32890196 Z M8.39542857,9.75321569 L7.64032653,7.18811765 L1.39338776,8.88576471 L0.154612245,4.6767451 L17.2623673,0.0285098039 L19.5713469,7.87321569 C20.7370612,11.8332157 19.4786939,14.5955686 15.9533878,15.5532157 C13.4648163,16.2296863 11.4501224,15.5669412 10.064,13.7108627 L4.57461224,19.694 L3.18195918,14.9622353 L8.39542857,9.75321569 Z",
    id: "Fill-5",
    fill: "#2EAEAD",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/_react["default"].createElement("polygon", {
    id: "Fill-8",
    fill: "#2EAEAD",
    points: "77 75.654661 78.9283769 72.1420106 85.9552956 75.9735937 90.5991828 78.6559813 90.6248197 78.6096782 80.9589008 68.444946 82.7226406 65.2328666 96.5253165 67.8641611 96.5509534 67.817858 91.7796827 65.366986 84.752764 61.5354028 86.6943599 58 102 66.345339 98.8907226 72.0066937 89.7792021 70.1613547 86.0634514 69.2460698 86.0378145 69.292772 88.7793623 71.9280582 95.2871335 78.5697617 92.3052395 84"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M75.475716,86.1818567 C73.7737747,83.0825262 71.6667826,82.1141334 69.4068343,83.2948307 C67.1703555,84.4632949 66.8284296,86.7094611 68.5307756,89.8087917 C70.2327169,92.9085169 72.339709,93.8765151 74.5761878,92.7084455 C76.8361361,91.5281428 77.178062,89.2811873 75.475716,86.1818567 M64.3871998,91.973272 C61.7015639,87.0827699 62.9725572,82.6669933 67.7048929,80.1951056 C72.4368241,77.7236124 76.9340605,79.127269 79.6192918,84.0177711 C82.3049277,88.9078786 81.010465,93.3366775 76.2781292,95.8081707 C71.5461981,98.2792692 67.0724311,96.8633795 64.3871998,91.973272",
    id: "Fill-10",
    fill: "#2EAEAD"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M43.2224672,91.2608957 C43.3282303,86.3118008 46.0545682,83.8931127 51.2681627,84.0036213 C56.4550125,84.1133234 59.102332,86.6457467 58.9969741,91.5952449 L58.7745069,102 L54.1492957,101.901994 L54.3733838,91.4173824 C54.4272784,88.8893956 53.3838301,87.6423414 51.1915756,87.59596 C48.9721712,87.5491753 47.8501098,88.7498481 47.7962151,91.2782383 L47.5717218,101.762447 L43,101.665651 L43.2224672,91.2608957 Z",
    id: "Fill-12",
    fill: "#2EAEAD"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    id: "Fill-14",
    fill: "#2EAEAD",
    points: "27.7415554 75 31.9976434 77.5759968 31.837392 88.4406962 31.6268657 91.3842355 31.648861 91.3978334 33.2022781 88.5302822 37.6131186 80.9746648 41 83.024344 32.2584446 98 28.0023566 95.4236033 28.162608 84.5589038 28.3731343 81.6157645 28.3507463 81.6021666 26.7977219 84.4697178 22.3868814 92.0249352 19 89.9748561"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    id: "Fill-16",
    fill: "#2EAEAD",
    points: "5.9776616 68.3547843 8.88046578 73.2778716 20.6774398 66 23 69.9381457 11.2022338 77.2168276 14.1189005 82.163009 11.141635 84 3 70.1917753"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Group-20",
    transform: "translate(0.000000, 45.000000)"
  }, /*#__PURE__*/_react["default"].createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/_react["default"].createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Clip-19"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.5173489,7.98556 L6.50309362,9.78316 L3.85239149,10.89836 L3.85926383,10.95076 L6.67773191,11.30476 L11.0537957,12.04316 L10.5173489,7.98556 Z M13.4882213,6.64276 L14.2773277,12.61076 L18.3780936,13.30516 L18.9772,17.83396 L0.712944681,14.02036 L-0.000161702128,8.62756 L16.6620298,0.32076 L17.2744766,4.95436 L13.4882213,6.64276 Z",
    id: "Fill-18",
    fill: "#2EAEAD",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/_react["default"].createElement("polygon", {
    id: "Fill-21",
    fill: "#2EAEAD",
    points: "19 39.7427981 17.9858648 44 1 40.2572019 2.01413522 36"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    id: "Fill-23",
    fill: "#2EAEAD",
    points: "28 23.9928534 25.1616702 28.1682256 14.4571458 27.2440357 11.5686045 26.8230338 11.553976 26.8451918 14.2736962 28.6347521 21.4175577 33.6771063 19.1588338 37 5 27.0063409 7.83832984 22.8313715 18.5428542 23.7555614 21.4310001 24.1765633 21.446024 24.1544053 18.7263038 22.3644421 11.5828377 17.3224908 13.8407708 14"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M36.1092027,3.67460477 L35.1637721,7.50095765 C33.2831827,6.4787449 31.5480442,6.42882195 29.5236475,7.45183991 C27.8127509,8.31703692 27.2687482,9.42903046 27.7412581,10.3260332 C28.1640517,11.1292291 29.2553441,11.1155406 31.7325285,10.3719301 C36.5525402,8.92215143 38.9972653,9.4503685 40.4394477,12.1896893 C42.0431051,15.2357947 40.0713008,18.4453576 36.2394511,20.3822877 C32.4799159,22.2825808 30.0060185,22.3369324 27.5444474,21.4286567 L28.1739128,17.5225881 C30.4074465,18.6361921 32.2358543,18.3994607 34.3563965,17.3277276 C36.1400186,16.4258936 36.7341484,15.4676949 36.2616385,14.5706922 C35.8762348,13.8387572 34.7487851,13.8999531 32.3685679,14.5948484 C28.2240399,15.7632066 25.2176444,15.907339 23.6139869,12.8612336 C22.0723721,9.93268866 23.4233395,6.52907046 27.785222,4.32440838 C30.7739498,2.8134338 33.2211401,2.59320916 36.1092027,3.67460477",
    id: "Fill-25",
    fill: "#2EAEAD"
  }))))));
};
OurMountains.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
OurMountains.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = OurMountains;